import { BellIcon } from '@phosphor-icons/react';
import React, { useState } from 'react';
import { IconButton } from 'ui-library/components/IconButton/IconButton';
import { Popover } from 'ui-library/components/Popover/Popover';
import type { NotificationsResponse } from '../../api/notifications/fetchNotifications';
import { fetchNotifications } from '../../api/notifications/fetchNotifications';
import { QueryKeys } from '../../api/queryKeys';
import { useQueryWithCallbacks } from '../../hooks/useQueryWithCallbacks';
import s from './SharedWithMeDropdown.module.scss';
import { SharedWithMePanel } from './SharedWithMePanel';

type SharedWithMeDropdownT = {
  triggerClassName?: string;
};

export const SharedWithMeDropdown: React.FC<SharedWithMeDropdownT> = ({ triggerClassName }) => {
  'use memo';

  const [isOpen, setIsOpen] = useState(false);

  const {
    data: sharedWithMeData,
    isError,
    isFetching,
    refetch,
  } = useQueryWithCallbacks<NotificationsResponse>({
    queryKey: [QueryKeys.fetchNotifications],
    queryFn: () => fetchNotifications(),
    retry: 2,
    refetchOnWindowFocus: false,
    enabled: isOpen,
  });

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <Popover.Trigger tooltip="Notifications">
        <IconButton size="sm" variant="clear" title="Notifications" className={triggerClassName}>
          <BellIcon />
        </IconButton>
      </Popover.Trigger>
      <Popover.Content side="bottom" align="end" sideOffset={7} className={s.dropdownMenu}>
        <SharedWithMePanel
          isLoading={!sharedWithMeData && (!isError || isFetching)}
          isError={isError}
          notifications={sharedWithMeData}
          onRetry={() => void refetch()}
          setIsOpen={setIsOpen}
        />
      </Popover.Content>
    </Popover>
  );
};
